import {Injectable} from "@angular/core";
import {CoreApiService} from "../../core/service/core-api.service";
import {ApiResponseDto} from "../../core/interfaces/core.types";
import {Observable} from "rxjs";
import {CsOverviewDto} from "../types/cs.types";

@Injectable({ providedIn: 'root' })
export abstract class CsApiService {

  endPoint: string = "mvseu/eu/cs"

  constructor(
    protected coreApiService: CoreApiService) {
  }


  /**
   * Get Overview.
   * @param phoneNumber
   */
  public getOverview() : Observable<CsOverviewDto> {
    return this.coreApiService.get(`${this.endPoint}/overview`);
  }

  /**
   * Select Level Option.
   * @param levelId
   * @param optionId
   */
  public selectOption(levelId: number, optionId: number) : Observable<CsOverviewDto> {
    return this.coreApiService.post({}, `${this.endPoint}/selectOption/${levelId}/${optionId}`);
  }

  /**
   * Redeem.
   * @param optionId
   */
  public redeem(optionId: number) : Observable<CsOverviewDto> {
    return this.coreApiService.post({},`${this.endPoint}/redeem/${optionId}`);
  }

}
